import React from 'react'

export default function UpsellingSkeleton() {
  return (
    <div className="flex flex-col py-4">
      <div className="flex space-x-2 sm:space-x-4 animate-pulse">
        <div className="rounded-lg min-w-[96px] h-24 bg-gray-200"></div>
        <div className="flex-1 flex flex-col py-1">
          <div className="w-3/5 h-4 bg-gray-200 rounded mb-2"></div>
          <div className="w-full h-4 bg-gray-200 rounded mb-2"></div>
          <div className="w-1/5 h-4 bg-gray-200 rounded mb-3"></div>
          <div className="w-2/5 h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  )
}
